import { render, staticRenderFns } from "./add-multiple-leads.vue?vue&type=template&id=0185d1cb&scoped=true"
import script from "./add-multiple-leads.vue?vue&type=script&lang=js"
export * from "./add-multiple-leads.vue?vue&type=script&lang=js"
import style0 from "./add-multiple-leads.vue?vue&type=style&index=0&id=0185d1cb&prod&lang=scss"
import style1 from "./add-multiple-leads.vue?vue&type=style&index=1&id=0185d1cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0185d1cb",
  null
  
)

export default component.exports